import * as joint from '@joint/core'

/**
 * C4 Container shape - rounded rectangle with technology label
 */
export const C4Container = joint.dia.Element.define(
  'c4.Container',
  {
    size: { width: 240, height: 160 },
    attrs: {
      body: {
        refWidth: '100%',
        refHeight: '100%',
        rx: 10,
        ry: 10,
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: 25,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 45,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Container]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 75,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '90%',
          height: 70,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      {
        tagName: 'rect',
        selector: 'body',
      },
      {
        tagName: 'text',
        selector: 'nameLabel',
      },
      {
        tagName: 'text',
        selector: 'typeLabel',
      },
      {
        tagName: 'text',
        selector: 'descriptionLabel',
      },
    ],
  }
)

export function createContainer(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[Container: ${technology}]` : '[Container]'

  const container = new C4Container({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return container
}
